export default __webpack_public_path__ + "static/media/dots-grey-horizontal.914795e9.svg";